import React from 'react';
import PropTypes from 'prop-types';

import SystemMessage from '../../SystemMessage/SystemMessage';

/**
 * Tells the counselor a favorite didn't reach the resident's record.
 *
 * The heart still toggles, because the favorite lives in a cookie first, so
 * nothing on screen looked wrong when Drupal refused it: the brochure just came
 * out without it (#1474). It stays up until dismissed or until a later favorite
 * saves, since the next save resends the whole list and fixes this one too.
 */
const FavoriteSyncError = ( { visible, onDismiss } ) => visible && (
  <div className="favoriteSyncError" role="alert">
    <SystemMessage
      status="error"
      title="A favorite didn't save"
      message="It still shows here, but it won't be on the brochure yet. Try favoriting again; if this keeps appearing, let support know."
      testId="favorite-sync-error"
    >
      <button
        type="button"
        className="favoriteSyncError__dismiss"
        onClick={onDismiss}
        data-testid="favorite-sync-error:dismiss"
      >
        Dismiss
      </button>
    </SystemMessage>
  </div>
);

FavoriteSyncError.propTypes = {
  visible: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
};

FavoriteSyncError.defaultProps = {
  visible: false,
};

export default FavoriteSyncError;
